import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  ErrorBoundaryState
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          height: '100vh', gap: 16, padding: '2rem', background: '#fff',
        }}>
          <div style={{
            background: '#fff5f5', border: '2px solid #fca5a5', borderRadius: 12,
            padding: '2rem 3rem', maxWidth: 500, textAlign: 'center',
          }}>
            <AlertTriangle size={40} color="#ef4444" style={{ marginBottom: 12 }} />
            <h2 style={{ color: '#b91c1c', margin: '0 0 8px', fontSize: 18 }}>Произошла ошибка</h2>
            <p style={{ color: '#64748b', fontSize: 13, margin: '0 0 16px' }}>
              Что-то пошло не так. Попробуйте обновить страницу.
            </p>
            {this.state.error && (
              <details style={{ textAlign: 'left', marginBottom: 16 }}>
                <summary style={{ cursor: 'pointer', color: '#94a3b8', fontSize: 12 }}>Детали ошибки</summary>
                <pre style={{ fontSize: 11, color: '#ef4444', marginTop: 8, overflow: 'auto', maxHeight: 150, background: '#fff', border: '1px solid #fca5a5', borderRadius: 6, padding: 8 }}>
                  {this.state.error.message}
                </pre>
              </details>
            )}
            <button
              onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: 6,
                background: '#ef4444', color: '#fff', border: 'none', borderRadius: 6,
                padding: '8px 20px', fontSize: 13, fontWeight: 600, cursor: 'pointer',
              }}
            >
              <RefreshCw size={14} /> Обновить страницу
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
